export default [
  { id: 1, name: 'Wildness',    performer: 'Dusted Digga',   promoter: 5, price: 1200.12, producer: ['Mitwirkender'], image: './img/DustedDigga-Wildness.png', details: [
      {id: 1, name: 'Wildness song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ]},
  { id: 2, name: 'Bubbles',     performer: 'Melo',   promoter: 2, price: 0, producer: ['Produzent'] , image: './img/Melo-Bubbles.png', details: [
      {id: 1, name: 'Bubbles song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ]},
  { id: 3, name: 'Into the Wild', performer: 'Payy', promoter: 3, price: 932.20, producer: ['Produzent', 'Mitwirkender'], image: './img/Payy-IntoTheWild.png', details: [
      {id: 1, name: 'Wild song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ]},
  { id: 4, name: 'Kobination', performer: 'Bligg', promoter: 1, price: 2083.50, producer: ['Mitwirkender'], image: './img/Bligg-Kobination.png', details: [
      {id: 1, name: 'Kobination song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ] },
  { id: 5, name: 'There Is No Way', performer: 'Dusted Digga', promoter: 0, price: 3592.10, producer: ['Mitwirkender'], image: './img/Crizz-AlbertHoffmann.png', details: [
      {id: 1, name: 'NoWay song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ] },
  { id: 6, name: 'Krime Time',  performer: 'Unknown',   promoter: 0, price: 0, producer: ['Mitwirkender'], image: './img/Bligg-Kobination.png', details: [
      {id: 1, name: 'KrimeTime song', code: 'CH908341343', length: '3:44'},
      {id: 2, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 3, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 4, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 5, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'},
      {id: 6, name: 'Ja aber...', code: 'CH908341343', length: '3:44'},
      {id: 7, name: 'Stammitisch', code: 'CH908341342', length: '3:44'},
      {id: 8, name: '1954', code: 'CH908341344', length: '3:44'},
      {id: 9, name: 'In Tüüfels Chuchi feat. ZID', code: 'CH908341334', length: '2:32'},
      {id: 10, name: 'Im freiä Fall',               code: 'CH908324134', length: '3:17'}
    ] }

]
